export default __webpack_public_path__ + "5d40dd64e2278fe436ba68ac7f1195a4.woff2";